import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onSign }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = ref.current;
    c.width = 600;
    c.height = 200;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0F2547";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (600 / r.width), y: (e.clientY - r.top) * (200 / r.height) };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    ref.current.setPointerCapture?.(e.pointerId);
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    if (!hasInk) setHasInk(true);
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onSign(ref.current.toDataURL("image/png"));
  };

  const clear = () => {
    const ctx = ref.current.getContext("2d");
    ctx.clearRect(0, 0, 600, 200);
    setHasInk(false);
    onSign(null);
  };

  return (
    <div>
      <canvas
        ref={ref}
        data-testid="signature-canvas"
        className="w-full h-40 rounded-lg border-2 border-dashed border-slate-300 bg-white touch-none cursor-crosshair"
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerCancel={end}
      />
      <div className="flex justify-between items-center mt-2">
        <p className="text-[11px] text-slate-400">{hasInk ? "Signature captured" : "Sign inside the box using finger or mouse"}</p>
        <button type="button" onClick={clear} data-testid="signature-clear-button"
          className="inline-flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-[#D5281B] min-h-[36px] transition-colors">
          <Eraser className="h-3.5 w-3.5" /> Clear
        </button>
      </div>
    </div>
  );
}
